
import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const ANSWERS = 'answers'

/**
 * Form model
 */
const formModel = () => {
  return {
    [ANSWERS]: {
      label: `${t('student.answers')}`,
      name: ANSWERS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {

  [ANSWERS]:  [],

}
/**
 * Form data validation
 */
export const validationSchema = () => yup.object().shape({
})

export default formModel
